import React from 'react'

import Button from '../../../Shared/Button'
import EmptyState from '../../../Shared/EmptyState'

export default function LogsEmptyState({ id }) {
  return (
    <EmptyState>
      <h2>No runs yet!</h2>
      <Button to={`/actions/${id}/run`} icon="run">
        Run Now
      </Button>
    </EmptyState>
  )
}
